import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Start from "@/pages/Start";
import Produkter from "@/pages/Produkter";
import SaFungerarDet from "@/pages/SaFungerarDet";
import OmVido from "@/pages/OmVido";
import Kontakt from "@/pages/Kontakt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Start />} />
          <Route path="/produkter" element={<Produkter />} />
          <Route path="/sa-fungerar-det" element={<SaFungerarDet />} />
          <Route path="/om-vido" element={<OmVido />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
